

import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, Type, ViewChild, ViewChildren } from '@angular/core';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { NicaDynamicContentComponent } from '../../components/nica-dynamic-content/nica-dynamic-content.component';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { alert, confirm } from 'devextreme/ui/dialog';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { UtilityService } from '../../services/utility.service';


@Component({
  selector: 'app-albo',
  templateUrl: './ana-albo.component.html',
  styleUrls: ['./ana-albo.component.css']
})
export class AnaAlboComponent extends NicaMaster implements OnInit {
  @ViewChild('formSoggetto', { static: false }) formSoggetto: NicaFormComponent;
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('dynamicComponent', { static: false }) dynamicComponent: NicaDynamicContentComponent;
  @ViewChild('nicaAnagrafica', { static: false }) nicaAnagrafica: NicaAnagraficaComponent;

  @Input() itemData: any
  @Input() InviaA: any
  @Output() onAllEvent: EventEmitter<any> = new EventEmitter<any>();
  alboTabs: any[];
  dataToSend: any[]
  templateTab: any = {
    AlboCategoria: 'grid',
    AlboCarrozzeriaMobile: 'grid'
  }
  selectedIndex: any =
    {

      AlboCategoria: 0,
      AlboCarrozzeriaMobile: 1,

    }
  categorieAlbo: any;
  firstLoad: boolean = true;

  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    public loader: NgxSpinnerService,
    public formservice: FormsTemplateService,
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService
  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService,


    );


  }


  ngOnInit(): void {

    if (this.itemData) {
      this.setGlobalVariableFromParams(this.itemData[0])
      this.setViewsAlboComponent(this.itemData[0])

    } else {
      this.activatedroute.queryParams.subscribe((params) => {

        this.currentTabId = params.currentTabId,
          this.currentTabName = params.currentTabName;
        this.setGlobalVariableFromParams(params);
        this.setViewsAlboComponent(params)
      })
    }
  }


  setViewsAlboComponent(params) {



    let queryString = '/' + this.filterID['idSede']

    this.anagraficaService.getElenco('AlboCategoria', '', queryString).then(resItems => {

      this.categorieAlbo = resItems['items']
      this.filterID['categorieAlbo'] = resItems['items'];
    })

    //this.filterID['templateTab'] = this.templateTab;

    this.setTabsAlbo(params);



    if (this.SubjectCall == 'AlboCarrozzeriaMobile' && this.template == 'grid') {
      this.SetToolbarButtons(this.serviceButtonsArray, this.filterID, null, null, true)
    }






  }


  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();

  }

  setTabsAlbo(param) {

    this.selectedIndex[this.SubjectCall];

    /* 
    if (this.filterID['templateTab']) {
      if (typeof this.filterID['templateTab'][this.SubjectCall] != 'undefined') {
        this.templateTab = this.filterID['templateTab']
        if (this.SubjectCall == 'albo')

          this.template = this.templateTab[this.SubjectCall];

      }
    }
    */

    const idCategoriaAlboGestore = Number(this.filterID['idCategoriaAlboGestore'])

    this.alboTabs = [

      {
        name: 'Categoria Albo',
        icon: 'glyphicon icon-albo-form',
        hint: 'categie dell\'albo',
        displayMode: 'in-line',
        path: 'main/anagrafica-albo',
        componentName: 'AnaAlboComponent',
        service: 'AlboCategoria',
        api: 'AlboCategoria',
        templateComponent: this.templateTab['AlboCategoria'],
        visible: true,
        disabled: this.filterID['idSede'] > 0 ? false : true,

      },
      {
        name: 'Aut. Carrozzerie',
        icon: 'glyphicon icon-albo-form',
        hint: 'Autorizzazione carrozzerie mobili',
        displayMode: 'in-line',
        path: 'main/anagrafica-albo',
        componentName: 'AnaAlboComponent',
        service: 'AlboCarrozzeriaMobile',
        api: 'AlboCarrozzeriaMobile',
        templateComponent: this.templateTab['AlboCarrozzeriaMobile'],
        visible: true,
        disabled: idCategoriaAlboGestore <= 70 ? false : true

      },

    ]

  }

  tabClick(ev) {


    const itemData = ev.itemData;

    if (itemData.service == this.SubjectCall) {
      return
    }

    let data = [];

    if (this.template == 'form') {
      const validation = this.formAnagrafica.validate();
      if (validation.isValid) {

        this.formAnagrafica.onFormSubmit();
      } else {

        return
      }
    }

    setTimeout(() => {

      switch (this.SubjectCall) {
        /*
          
          Quando Sono nella TAB AlboCategoria devo passare i dati alle altre tab.
          il dato costante da inviare è alle tab relazionate id ovvero idAlboCategoria
    
        */


        case 'AlboCategoria':


          data = this.formAnagrafica.dataSet;

          this.filterID['idAlboCategoria'] = data['id'];
          this.filterID['idCategoriaAlboGestore'] = data['idCategoriaAlboGestore'];
          /*
            Se la tab AlboCarrozzeriaMobile è già stata visitata verifico se è in modalità form e se nei filtri è prensete l'id idAlboCarrozzeriaMobile,
            Se presente lo setto per visualizzare i dati della Form in AlboCarrozzeriaMobile
          */

          if (this.filterID['idAlboCarrozzeriaMobile'] && this.filterID['templateTab']['AlboCarrozzeriaMobile'] == 'form') {
            data['id'] = this.filterID['idAlboCarrozzeriaMobile'];
            this.filterID['isEdit'] = true
          }


          /**Controllo l'Oggetto templateTab  se risulta definito gli associo il template Attuale della tab AlboCategoria 
           altrimenti setto  l'oggetto con la varibile templateTab dove sono definiti i valori di default delle due tab **/

          if (typeof this.filterID['templateTab'] != 'undefined') {
            this.filterID['templateTab']['AlboCategoria'] = this.template
          } else {
            this.filterID['templateTab'] = this.templateTab;
            this.filterID['templateTab']['AlboCategoria'] = this.template
          }


          this.templateTab['AlboCategoria'] = this.template

          break;


        case 'AlboCarrozzeriaMobile':
          /*
          Quando Sono nella TAB AlboCarrozzeriaMobile devo passare i dati alle altre tab.
          il dato costante da inviare è idAlboCategoria, tuttavia se ritorno sulla tab Albo categoria 
          devo ritornare sulla Form ed il mio campo costante è id che nelle altre tab è  settato come idAlboCategoria
          Inoltre setto anche idAlboCarrozzeriaMobile, in modo da poterlo conservare e inviarlo nuovamente alla tab AlboCarrozzeriaMobile 
          se sono in visualizzazione form così da avere di nuovo il dettaglio della carrozzeria mobili attulmente visualizzata.
          */

          if (this.template == 'form') {
            data = this.formAnagrafica.dataSet;
            this.filterID['idAlboCarrozzeriaMobile'] = data['id'];
            this.filterID['isEdit'] = true
          } else {
            data = this.filterID
            this.filterID['idAlboCarrozzeriaMobile'] = data['idAlboCarrozzeriaMobile'];
            this.filterID['isEdit'] = true
          }


          data['id'] = data['idAlboCategoria'];
          this.filterID['idAlboCategoria'] = data['idAlboCategoria'];

          this.templateTab['AlboCarrozzeriaMobile'] = this.template

          this.filterID['templateTab']['AlboCarrozzeriaMobile'] = this.template
          break;
      }


      this.refreshPage(data, '', itemData.service, this.filterID['templateTab'][itemData.service], itemData);


    }, 300);


  }

  onOptionChanged(ev) {

  }




  formGridEvent(e) {

    console.log('formGridEvent-->', e)

    if (e.name == "saveEditorData") {
      let res = this.checkAndRemoveDuplicates(e.dataSource, 'id');

      e.component.dataSource = res;

    }

    if (e.name == "toolbarButtonClick") {
      let eventName = e.infoEventButtons


      if (this.SubjectCall == 'AlboCarrozzeriaMobile' && eventName == 'CopiaCerDaAlboCategoria') {
        confirm('Eventuali EER già presenti verranno rimossi proseguire?', 'Attenzione!').then(res => {
          if (!res) {
            return
          } else {
            if (this.filterID['isEdit']) {


              const idAlboCarrozzeria = this.formAnagrafica.dataSet.id
              let api = this.apiset + '/CopiaCerDaAlboCategoria?IdAlboCarrozzeria=' + idAlboCarrozzeria;
              const data = []
              this.anagraficaService.actionInsert(api, data).then(res => {
                this.refreshPage(this.formAnagrafica.dataSet, '', this.SubjectCall, this.template)
              })
            } else {

              const idAlboCategoria = this.formAnagrafica.dataSet.idAlboCategoria
              let api = 'AlboCategoria';
              let queryString = '?id=' + idAlboCategoria
              this.anagraficaService.getValue(api, '', queryString).then(res => {
                if (res['listaCer'].length > 0) {

                  this.formAnagrafica.formRefreshInputData('listaCer', res['listaCer']);
                  this.formAnagrafica.formGridDataSourceUpload(res['listaCer'], 'listaCer')

                }
              })
            }

          }
        })
      }

      if (this.SubjectCall == 'AlboCarrozzeriaMobile' && eventName == 'CopiaCerDaAlboCarrozzeria') {
        this.showAutorCarroz()
      }
      if (this.SubjectCall == 'AlboCarrozzeriaMobile' && eventName == 'incollaCer') {
        // this.utilityService.leggiCopiaInMemoria().then((text)=>{
        //   if(text)alert('text','Incollato')
        // }).catch(()=>{})
        this.utilityService.leggiCopiaInMemoria(e.masterComponent).then((txt) => {
          if (txt) {
            confirm('Eventuali EER già presenti verranno rimossi proseguire?', 'Attenzione!').then((res) => {
              if (res) {
                this.utilityService.estraiCerListDaStringa(txt).then((cerArray) => {
                  //console.log(cerArray)
                  if (cerArray && typeof cerArray !== 'boolean') {

                    this.anagraficaService.getValue('cer', '', `?$filter=(not endswith(id,'00'))`).then((res: { [key: string]: any }) => {
                      const data = []
                      cerArray.forEach((string) => {
                        const tmp = res.items.filter((value) => value.id == string)
                        // console.log(tmp)
                        if (tmp.length == 1) {
                          data.push(tmp[0])
                        }
                      })
                      this.formAnagrafica.formRefreshInputData('listaCer', data);
                      this.formAnagrafica.formGridDataSourceUpload(data, 'listaCer')
                    })
                  }
                })

              }
            })
          }
        })
      }

    }

  }

  showAutorCarroz() {


    const id = this.formAnagrafica.dataSet.id;
    let editData = ''
    if (this.filterID['isEdit']) {
      editData = '$filter=((id lt ' + id + ' ))&'
    }
    let queryString = '?' + editData + 'idAlboCategoria=' + this.filterID['idAlboCategoria']


    let instancedDataGrid = {
      service: null,
      api: 'AlboCarrozzeriaMobile',
      remoteOperation: true,
      rowAlternate: true,
      queryString: queryString,
      isEditable: false,
      isEditableNewRow: false,
      isEditableEditRow: false,
      isEditableDeleteRow: false,
      tableHeight: 500,
      tableWidth: 600,
      showFilter: false,
      colonne: [
        {
          type: 'campoSpecial',
          dataField: "idCarrozzeriaAlboGestore",
          caption: "Tipo Carrozzeria",

          lista: {
            dataSource: 'CarrozzeriaAlboGestore',
            valueExpr: 'id',
            displayExpr: 'descrizione',
            static: false,

          }
        },
      ],
      selectionRowMode: 'single',
      selectedData: null,
      isOdata: true,
      idTable: 'CarrozzeriaAlboGestore',
      showToolbarTop: false,
      showToolbarBottom: false,
      isSearchable: true,

    }



    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, 'NicaDataGridComponent', null, '600', null, instancedDataGrid, true, true, 'Elenco carrozzerie autorizzate');
    this.userComponentService.outputComponent.subscribe(currentOutput => {

      console.log('currentOutput', currentOutput)

      if (currentOutput.name == "onRowSelectionChange" && guid == currentOutput.guid) {
        confirm('Eventuali EER già presenti verranno rimossi proseguire?', 'Attenzione!').then(resp => {
          if (!resp) {
            this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            return
          } else {
            let e = currentOutput.data;

            if (this.filterID['isEdit']) {
              const apiS = this.apiset + '/CopiaCerDaAlboCarrozzeria?IdAlboCarrozzeriaOrigine=' + e.id + '&IdAlboCarrozzeriaDestinazione=' + id
              this.anagraficaService.actionInsert(apiS, []).then(res => {
                this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)

                this.refreshPage(this.formAnagrafica.dataSet, '', this.SubjectCall, this.template)

              })
            } else {

              //console.log(e)
              this.formAnagrafica.formRefreshInputData('listaCer', e.listaCer);
              this.formAnagrafica.formGridDataSourceUpload(e.listaCer, 'listaCer')

              this.userComponentService.destroyCurrentOpenPopUpByGuid(guid)
            }

          }


        })

      }
    })




    return

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === 'NicaDynamicContentComponent');

    this._overlaySidePanelService.setTitle('Elenco carrozzerie autorizzate');
    this._overlaySidePanelService.setToolBarVisible(true);
    this._overlaySidePanelService.setContent(factoryClass);

    let height = 500;

    let campo = {

      dataField: 'AlboCarrozzeriaMobile',
      dynamic: {
        dataSource: 'AlboCarrozzeriaMobile',
        service: '',
        valueExpr: '',
        campoTabRif: '', //In edit o in insert sarà sempre l'id che mi verrà restituito dalle API
        displayExpr: 'id',
        related: ['listaCer'],
        componentType: 'dynamicGrid',
        settingGrid: {
          campoTabRif: 'idAlboCategoria', //è il campo di rif. con il quele effettuare le operazioni di insert, edit e delete della griglia.
          masterKey: 'id',
          keyUnique: '',
          mode: 'cell',
          remoteOperations: true,
          hoverStateEnabled: true,
          rowAlternationEnabled: true,
          repaintChangesOnly: true,
          allowUpdating: false,
          allowDeleting: false,
          allowAdding: false,
          height: 630,
          showColBlank: false,
          showFilterSearch: false,
          colonne: [
            {
              type: 'campoSpecial',
              dataField: "idCarrozzeriaAlboGestore",
              caption: "Tipo Carrozzeria",
              editorType: "",
              colWidth: '100%',

              lista: {
                dataSource: 'CarrozzeriaAlboGestore',
                valueExpr: 'id',
                displayExpr: 'descrizione',
                static: false,

              }
            },
          ]
        }

      }


    }



    this._overlaySidePanelService.sendDataToComponent([

      {
        componentData: campo,
        apiSource: 'AlboCarrozzeriaMobile',
        componentType: 'dynamicGrid',
        filterKey: '',
        height: height,
        width: '',
        dataInput: '',
        dataForm: ''

      }
    ]);
    this._overlaySidePanelService.sendClassToComponent('soggetto-form')

    this._overlaySidePanelService.setPopupWidth(800);
    this._overlaySideFormService.setPopupHeight(height + 80);



    this._overlaySidePanelService.show();

    this._overlaySidePanelService.onPanelClose().subscribe(
      (ev) => {

        /*  this.datasource[this.currEditIndx][campo.dataField]
   
         this.dynamicGridComponent.instance.editCell(this.currEditIndx, campo.dataField)
   
         const element = this.dynamicGridComponent.instance.getCellElement(this.currEditIndx, campo.dataField)
         this.dynamicGridComponent.instance.focus(element);
         this.onEditCanceled()  */

      }
    )



    setTimeout(() => {

      (this._overlaySidePanelService._hrefComponent.instance.emittendSelectionRow as EventEmitter<any>).subscribe(


        (res) => {

        }
      )
    }, 300)

  }

}
